var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.messages.length!==0)?_c('div',{staticClass:"alert show"},[_c('ul',_vm._l((_vm.messages),function(msg,index){return _c('li',{key:'key-'+index},[_c('div',{domProps:{"innerHTML":_vm._s(msg)}})])}),0)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }